var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"pos-relative"},[_c('v-card',{staticClass:"pos-absolute",staticStyle:{"z-index":"-1"}},[_c('div',{staticClass:"monitor",class:{ 'pos-absolute': !_vm.getWebrtcStatus },staticStyle:{"z-index":"-1"},attrs:{"id":"monitor"}},[_c('video',{ref:"video",attrs:{"autoplay":"","playsinline":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }